import React from "react";

import Button, { ButtonTypes } from "../../../../components/Button";
import { Caption, Pill } from "../../styles";
import { DecisionCard, DecisionSummary, DecisionWarning } from "../styles";
import { DecisionBannerProps } from "../types";

export const DecisionBanner: React.FC<DecisionBannerProps> = ({
  resolution,
  hasNextItem,
  isSubmitting,
  onNext,
}) => {
  const warning = resolution.kind === "request" ? resolution.warning : null;
  const recordedLabel =
    resolution.kind === "instrument" ? "Fix recorded" : "Decision recorded";

  return (
    <DecisionCard role="status">
      <DecisionSummary>
        <Pill $tone="healthy">{recordedLabel}</Pill>
        <span>{resolution.summary}</span>
        {warning && <DecisionWarning role="alert">{warning}</DecisionWarning>}
      </DecisionSummary>
      {hasNextItem ? (
        <Button
          type={ButtonTypes.primary}
          disabled={isSubmitting}
          onClick={onNext}
        >
          Next item
        </Button>
      ) : (
        <Caption>No more items in this view.</Caption>
      )}
    </DecisionCard>
  );
};
